import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function getContainerClassName(_ref) {
  var _ref$available = _ref.available,
    available = _ref$available === void 0 ? true : _ref$available;
  var extraClassNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var classNames = ['menu-item'];
  if (!available) {
    classNames = [].concat(_toConsumableArray(classNames), ['not-available']);
  }
  classNames = [].concat(_toConsumableArray(classNames), _toConsumableArray(extraClassNames));
  return classNames.join(' ');
}